<template>
  <div>
    <div id="loading-bg" v-if="isLoading">
      <div class="loading-logo">
        <img src="@/assets/images/logo/logo-no-text.svg" alt="Logo">
      </div>
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>
    <access-denied v-if="showAccessDenied" />
    <password-expired v-if="showPasswordExpired" />
  </div>
</template>

<script>
import AccessDenied from "@/layouts/components/auth/AccessDenied";
import PasswordExpired from "@/layouts/components/auth/PasswordExpired";

export default {
  components: {
    AccessDenied,
    PasswordExpired,
  },
  watch: {
    authenticated: {
      handler(newValue) {
        const doNotRedirect = this.isAccessDenied || this.isPasswordExpired;

        if (newValue && !doNotRedirect) {
          this.$router.go('/')
        }
      },
      immediate: true,
    }
  },
  computed: {
    authenticated() {
      return this.$auth.isAuthenticated;
    },
    isLoading() {
      return (this.$auth.loading);
    },
    isAccessDenied() {
      return this.$store.getters['auth/accessDenied'];
    },
    isPasswordExpired() {
      return this.$store.getters['auth/passwordExpired'];
    },
    showAccessDenied() {
      return (this.isAccessDenied && !this.isLoading);
    },
    showPasswordExpired() {
      return (this.isPasswordExpired && !this.isLoading);
    },
  }
};
</script>

<style lang="scss">
@import "../assets/css/loader.css";
</style>
